import AuthService from "../login/auth.service";
import { compromisoSocio } from "../../components/generico/utils/UrlAPI";
import { comprobantes } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class PagoAporteService {
  async pagosSeleccionados(_codigoProducto) {
    var data = JSON.stringify({ canal: "WEB", modo: "S" });
    var config = {
      method: "post",
      url: compromisoSocio+"aporte/pagoAporte",
      headers: {
        "Content-Type": "application/json",
        "Authorization":"Bearer "+AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }

  async pagosConfirmados(_cuentaDebito, _importeEfectivo, _codigoProducto) {
    //falta numero de operacion
    var data = JSON.stringify({
      canal:"WEB",
      cuentaDebito: _cuentaDebito,
      importeDebito: _importeEfectivo
    });

    var config = {
      method: "post",
      url: compromisoSocio+"aporte/pagoAporte",
      headers: {
        "Content-Type": "application/json",
        "Authorization":"Bearer "+AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }

  async descagarComponente(titulo, nroOperacion, nroSocioTitular, cuenta, moneda, total) {
    
    var _url = comprobantes + "comprobantes/v2/compromisos";


    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nroSocioTitular: nroSocioTitular,
      cuenta: cuenta,
      moneda: moneda,
      total: total,
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
  }
}
export default new PagoAporteService();
